import isEmpty from 'lodash/isEmpty'

export const getFormErrors = (advancedSettings, formData, requiresApproval) => {
  const errors = []

  if (
    (requiresApproval ||
      advancedSettings?.justificationSetting?.isJustificationRequiredAtCheckout) &&
    isEmpty(formData?.justification)
  ) {
    errors.push('Justification is a mandatory field.')
  }

  if (
    requiresApproval &&
    advancedSettings?.justificationSetting?.justificationRegex
  ) {
    const regex = new RegExp(
      advancedSettings?.justificationSetting?.justificationRegex
    )

    if (!regex.test(formData?.justification)) {
      errors.push(
        `Justification should match the RegEx "${advancedSettings?.justificationSetting?.justificationRegex}".`
      )
    }
  }

  if (advancedSettings?.itsmSetting?.isITSMEnabled) {
    if (isEmpty(formData?.ticketType)) {
      errors.push('Ticket Type is a mandatory field.')
    }

    if (isEmpty(formData?.ticketId)) {
      errors.push('Ticket ID is a mandatory field.')
    }
  }

  return errors
}

export const isJustificationRegexRequired = (advancedSettings, requiresApproval) => {
  if (
    requiresApproval &&
    advancedSettings?.justificationSetting?.justificationRegex
  ) {
    return true
  }

  if (
    advancedSettings?.justificationSetting?.isJustificationRequiredAtCheckout &&
    advancedSettings?.justificationSetting?.justificationRegex
  ) {
    return true
  }

  return false
}
